import { permissionSystem } from '@adflow/shared/util-permissions';
import type { PatchMinifier } from '@adflow/shared/util-superstruct';
import {
	minPatchPrimitive,
	minPatchRecord,
} from '@adflow/shared/util-superstruct';

import type { EditPermissionsDto } from './edit-permissions.dto';

export const minPatchEditPermissionsDto: PatchMinifier<
	EditPermissionsDto | undefined
> = minPatchRecord(
	permissionSystem.permissionTypes,
	minPatchRecord(permissionSystem.actionTypes, minPatchPrimitive)
);
